module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.color !== '') ? _c('button', {
    style: ('background-color: ' + _vm.color + '; border: thin solid ' + _vm.color),
    on: {
      "click": function (e) { return _vm.$emit('click', e.target.clicked); }
    }
  }) : _c('button', {
    style: ('border: thin solid grey'),
    on: {
      "click": function (e) { return _vm.$emit('click', e.target.clicked); }
    }
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5e502929","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/forecasts/pages/sections/itemsColor/ItemColor.vue
// module id = 3214
// module chunks = 0